import React from "react";
import { CaretRight, Popcorn } from "phosphor-react";

const Card = ({ data }) => {
  return (
    <>
      <a
        href={`/genres/${data.id}`}
        className="relative inline-flex items-center w-full transition-all duration-300 ease-in-out hover:-translate-y-3 hover:shadow-2xl cursor-pointer p-4 bg-white rounded-xl border"
      >
        <div className="flex items-center w-full justify-between">
          <div className="flex space-x-4 items-center">
            <div className="flex items-center justify-center h-14 w-14 rounded-full bg-slate-50">
              <Popcorn size={24} />
            </div>
            <h1 className="text-lg font-bold">{data.name}</h1>
          </div>
          <div className="transition-all duration-300 ease-in-out bg-blue-50 rounded-lg text-sm lg:text-base p-2 hover:bg-blue-500 hover:text-white">
            <CaretRight size={16} />
          </div>
        </div>
        <div className="flex justify-between absolute w-full left-0">
          <div className=" w-1 bg-blue-500 h-9 rounded-r-2xl"></div>
          <div className="w-1 bg-blue-500 h-9 rounded-l-2xl"></div>
        </div>
      </a>
    </>
  );
};

export default Card;
